import React from 'react';
import { PartnerLedgerTransactions } from '../components/integration/PartnerLedgerPages';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

function EINSTransactions({ user }: { user: UserInfo }) {
  return <PartnerLedgerTransactions partner="EINS" user={user} />;
}

export default React.memo(EINSTransactions);
